export enum Custom_Field_Definition_Type {
	Boolean = 'BOOLEAN',
	String = 'STRING',
	Date = 'DATE',
	Currency = 'CURRENCY'
}

export type Custom_Field_Definition_Label = {
	nl?: string,
	fr?: string,
	en?: string
}

export type Custom_Field_Definition = {
	path: string,
	type: Custom_Field_Definition_Type,
	label: Custom_Field_Definition_Label
}
